module.exports = __webpack_public_path__ + "static/media/hollow_bar_postlapSMAP.1d8dcd82.svg";